/* Productfoto's uitvergroten, alleen op desktop.

   Waarom dit nodig is
   -------------------
   De rasterfoto's op de productpagina staan op aspect-ratio 1/1 met
   object-fit:cover. Een staande of liggende foto wordt daar dus bijgesneden en
   de bezoeker kan het hele beeld nergens zien. Op mobiel bestaat dat probleem
   niet: daar staat een veegcarrousel met duimnagels die het beeld heel laat.
   Deze lade is er daarom bewust alleen voor desktop.

   Wat er NIET in gaat
   -------------------
   Video's, externe video's en 3D-modellen. Die hebben hun eigen bediening en
   een still van een video uitvergroten helpt niemand. De selector pakt alleen
   img-elementen en slaat alles binnen .afs2-mv over.

   Instellingen komen uit window.AFS2Z_CFG, gezet door sections/afs2-zoom.liquid.
   Niet uit document.currentScript: dat is leeg zodra het bestand ooit als module
   of via een injectie geladen wordt, en dan vallen alle labels stil terug op het
   Engels zonder dat iemand het merkt. */
(function () {
  'use strict';
  if (window.__afs2Zoom) return;
  window.__afs2Zoom = true;

  var C = window.AFS2Z_CFG || {};
  var MIN = parseInt(C.minWidth, 10) || 990;
  var MAXW = parseInt(C.maxImage, 10) || 1800;
  var T = {
    close: C.closeLabel || 'Close',
    prev: C.prevLabel || 'Previous image',
    next: C.nextLabel || 'Next image',
    of: C.ofWord || 'of',
    zoom: C.zoomLabel || 'View larger'
  };

  var gal = document.querySelector('.afs2-gal');
  if (!gal) return;

  function thumbs() {
    return [].slice.call(
      gal.querySelectorAll('.afs2-gal__hero img, .afs2-gal__grid img')
    ).filter(function (im) { return !im.closest('.afs2-mv'); });
  }
  if (!thumbs().length) return;

  /* Shopify levert het formaat via een width-parameter. Dezelfde foto groter
     opvragen is dus een kwestie van dat getal vervangen, niet van een tweede
     bestand. Staat hij er niet op, dan plakken we hem erachter. */
  function bigSrc(img) {
    var s = img.getAttribute('src') || '';
    if (!s) return '';
    if (/[?&]width=\d+/.test(s)) return s.replace(/([?&]width=)\d+/, '$1' + MAXW);
    return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + MAXW;
  }

  var box, imgEl, countEl, prevBtn, nextBtn, closeBtn;
  var list = [], i = 0, opener = null, scrollPad = '';

  function icon(d) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '"/></svg>';
  }

  function build() {
    box = document.createElement('div');
    box.className = 'afs2z';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', T.zoom);
    box.innerHTML =
      '<img class="afs2z__img" alt="">' +
      '<button type="button" class="afs2z__btn afs2z__prev" aria-label="' + T.prev + '">' + icon('M15 5l-7 7 7 7') + '</button>' +
      '<button type="button" class="afs2z__btn afs2z__next" aria-label="' + T.next + '">' + icon('M9 5l7 7-7 7') + '</button>' +
      '<button type="button" class="afs2z__btn afs2z__x" aria-label="' + T.close + '">' + icon('M6 6l12 12M18 6L6 18') + '</button>' +
      '<div class="afs2z__count"></div>';
    document.body.appendChild(box);

    imgEl = box.querySelector('.afs2z__img');
    countEl = box.querySelector('.afs2z__count');
    prevBtn = box.querySelector('.afs2z__prev');
    nextBtn = box.querySelector('.afs2z__next');
    closeBtn = box.querySelector('.afs2z__x');

    /* Alleen de achtergrond sluit. Een klik op de foto zelf of op een knop niet,
       anders sluit het ding onder je handen weg bij het doorbladeren. */
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });
  }

  function preload(n) {
    if (!list[n]) return;
    var p = new Image();
    p.src = bigSrc(list[n]);
  }

  function show(n) {
    if (!list.length) return;
    i = (n + list.length) % list.length;
    var src = bigSrc(list[i]);
    if (imgEl.getAttribute('src') !== src) {
      box.classList.add('is-swapping');
      imgEl.onload = function () { box.classList.remove('is-swapping'); };
      imgEl.onerror = function () { box.classList.remove('is-swapping'); };
      imgEl.setAttribute('src', src);
    }
    imgEl.setAttribute('alt', list[i].getAttribute('alt') || '');
    var single = list.length < 2;
    countEl.textContent = single ? '' : (i + 1) + ' ' + T.of + ' ' + list.length;
    countEl.hidden = single;
    prevBtn.hidden = single;
    nextBtn.hidden = single;
    preload(i + 1 >= list.length ? 0 : i + 1);
    preload(i - 1 < 0 ? list.length - 1 : i - 1);
  }

  function go(step) { show(i + step); }

  function open(n, from) {
    if (!box) build();
    list = thumbs();
    opener = from || null;
    show(n);
    /* De schuifbalk verdwijnt zodra de pagina op overflow:hidden gaat, en dan
       springt de hele achtergrond een paar pixels naar rechts. Die breedte
       teruggeven als padding houdt het stil. */
    var html = document.documentElement;
    var sw = window.innerWidth - html.clientWidth;
    scrollPad = html.style.paddingRight;
    html.style.overflow = 'hidden';
    if (sw > 0) html.style.paddingRight = sw + 'px';
    box.classList.add('is-open');
    closeBtn.focus();
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    var html = document.documentElement;
    html.style.overflow = '';
    html.style.paddingRight = scrollPad;
    if (opener && typeof opener.focus === 'function') opener.focus();
    opener = null;
  }

  function isOpen() { return box && box.classList.contains('is-open'); }

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); go(1); return; }
    /* Tab mag de lade niet uit lopen, anders staat de focus onzichtbaar
       ergens op de pagina eronder. */
    if (e.key === 'Tab') {
      var f = [].slice.call(box.querySelectorAll('button')).filter(function (b) { return !b.hidden; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  var mq = window.matchMedia('(min-width: ' + MIN + 'px)');

  function onClick(e) {
    if (!mq.matches) return;
    var img = e.target.closest && e.target.closest('.afs2-gal__hero img, .afs2-gal__grid img');
    if (!img || !gal.contains(img) || img.closest('.afs2-mv')) return;
    e.preventDefault();
    var all = thumbs();
    open(all.indexOf(img), img);
  }

  function apply() {
    if (mq.matches) {
      gal.classList.add('afs2z-on');
      thumbs().forEach(function (im) {
        im.setAttribute('role', 'button');
        im.setAttribute('tabindex', '0');
        if (!im.getAttribute('title')) im.setAttribute('title', T.zoom);
      });
    } else {
      gal.classList.remove('afs2z-on');
      if (isOpen()) close();
    }
  }

  gal.addEventListener('click', onClick);
  gal.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (!e.target.matches || !e.target.matches('.afs2-gal__hero img, .afs2-gal__grid img')) return;
    e.preventDefault();
    onClick(e);
  });

  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
  apply();
})();